// Palette
import palette from "../palette";

type MuiChipType = { [k: string]: any };

const MuiChip: MuiChipType = {
  root: {
    backgroundColor: palette.primary.light,
    color: "#425A70",
  },
  clickable: {
    "&:hover, &:focus, &:active": {
      backgroundColor: "#EDF0F2",
    },
  },
  deletable: {
    "&:hover": {
      backgroundColor: palette.primary.light,
    },
  },
  outlined: {
    "&:hover": {
      backgroundColor: palette.primary.light,
    },
  },
};

export default MuiChip;
